import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import { AngularFireAuth } from "@angular/fire/auth";
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-gerenciar-promocoes',
  templateUrl: './gerenciar-promocoes.component.html',
  styleUrls: ['./gerenciar-promocoes.component.scss', '../../styles/estilo.padrao.scss']
})
export class GerenciarPromocoesComponent implements OnInit {
  uid;
  promocoesForm: FormGroup;
  gruposPromocoesSource;
  produtosSource: any = new MatTableDataSource([]);
  displayedColumns: string[] = ['Nome', 'Produtos', 'QuantidadeMinima', 'Status', 'AtivarDesativar'];
  displayedColumns_produtos: string[] = ['Codigo', 'NomeProduto', 'Remover'];
  produtos_tabela = [];

  bCaracterEspecial: boolean = false;
  auxObservableNomesProdutos;
  produtos;


  produtosDesconto = [];
  bPermissaoCadastrar: boolean = false;
  bCadastroConsulta: boolean = false;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth,
    private dialog: MatDialog,
  ) {
    this.uid = localStorage.getItem('uid');

    //Validar Permissões
    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.usuarioService.getFuncionario(this.uid).subscribe(dados => {
          if (dados) {
            const dadosFuncionario: any = dados;
            this.bPermissaoCadastrar = dadosFuncionario.Permissoes.Cadastrar.Clientes;
          }
        });
      } else
        this.bPermissaoCadastrar = true;
    });
  }

  ngOnInit(): void {
    this.promocoesForm = this.formBuilder.group({
      nomeGrupo: ['', [Validators.required]],
      nomeProduto: ['', null],
      quantidadeMinima: [1, [Validators.required]],
    });

    this.buscarGruposPromocoes();
  }

  buscarGruposPromocoes() {
    this.spinner.show('gerenciar-promocoes');

    this.usuarioService.getGruposPromocoes().pipe(take(1)).subscribe(snap => {
      let auxGrupos = [];
      let dados;
      let i;
      let sAuxNomeProdutos = '';
      this.gruposPromocoesSource = null;

      if (snap.length > 0) {
        snap.forEach((item, index) => {
          dados = item.payload.val();

          sAuxNomeProdutos = '';
          for (i = 0; i < dados.Produtos.length; i++) {
            sAuxNomeProdutos = sAuxNomeProdutos + dados.Produtos[i].Nome + '; ';
          }

          auxGrupos.push({
            ID: item.key,
            Status: dados.Status,
            Nome: dados.Nome,
            Produtos: dados.Produtos,
            ProdutosString: sAuxNomeProdutos,
            QuantidadeMinima: dados.QuantidadeMinima
          });

        });
      }

      this.gruposPromocoesSource = new MatTableDataSource(auxGrupos);

      setTimeout(() => this.spinner.hide('gerenciar-promocoes'), 300);
    });
  }


  cadastrarGrupo() {
    if (this.promocoesForm.valid) {
      this.spinner.show('defaul');
      const map = {
        Status: true,
        Nome: this.f.nomeGrupo.value.trim(),
        NomeBusca: this.f.nomeGrupo.value.trim().toLowerCase(),
        Produtos: this.produtos_tabela,
        QuantidadeMinima: this.f.quantidadeMinima.value
      }

      this.usuarioService.setGrupoPromocao(map).then(resp => {
        setTimeout(() => {
          this.spinner.hide('defaul');
          this.voltar();
        }, 300);
      })
    }
  }

  novoGrupoPromocional() {
    this.produtos_tabela = [];
    this.bCadastroConsulta = true;
  }

  ativarDesativarGrupo(grupo) {
    this.spinner.show('defaul');

    this.usuarioService.updateStatusGrupoPromocional(grupo.ID, !grupo.Status).then(resp => {
      setTimeout(() => {

        this.usuarioService.setLog("Alterou o status do grupo promocional: " + grupo.ID + " Nome: " + grupo.Nome + " para: " + !grupo.Status, null, this.uid);
        this.spinner.show('hide')
        this.voltar();
      }, 300);
    });
  }

  removerProduto(prod) {
    const index = this.produtos_tabela.findIndex(x => x.ID === prod.ID);

    if (index !== -1) {
      const aux = this.produtos_tabela.filter(item => item.ID !== prod.ID);
      this.produtos_tabela = aux;
      this.produtosSource = new MatTableDataSource(this.produtos_tabela);
    }
  }

  adicionarProduto(prod) {
    const index = this.produtos_tabela.findIndex(x => x.ID === prod.ID);
    if (index === -1) {
      this.produtos_tabela.push(prod);
      this.produtosSource = new MatTableDataSource(this.produtos_tabela);
    } else {
      this.toastr.warning('Produto já adicionado à lista', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    }
    this.promocoesForm.get('nomeProduto').patchValue('');
  }

  onChangeNomeProduto(e) {
    if (e.length >= 4) {
      this.auxObservableNomesProdutos = this.usuarioService.getBuscaInicioNomeProduto(this.uid, e.toLowerCase()).subscribe(snap => {
        var dados;
        this.produtos = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.NomeBusca.includes(e.toLowerCase())) {
            this.produtos.push({
              ID: item.key,
              Codigo: dados.CodigoProduto,
              //Parte 1
              Nome: dados.Nome,
              ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
            });
          }
        });
      });
    }
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/gerenciar-promocoes"]));
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;

    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
      return true;
    } else {
      this.bCaracterEspecial = true;
      return false;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.promocoesForm.controls; }
}
